
import { User,ReqLoginData,UpdateTimes } from '../interface/index'
import http from '../core/http'


/**
 * @name 登录模块
 */
// * 用户登录接口
export const loginApi = (params: ReqLoginData) => {
    return http.post<User>('/api/home/login', params)
}
// * 用户登录接口
export const NeedGeetestCheck = (params: ReqLoginData) => {
    return http.post<string>('/api/home/NeedGeetestCheck', params)
}
export const getUpdatetime = ()=>{
    return  http.get<UpdateTimes>('/api/home/report/updatetime')
} 
export const exportYj01 = () => {
    return http.download('/api/export/yj01',undefined,{responseType:'blob'})
}
export const exportYj02 = () => {
    return http.download('/api/export/yj02',undefined,{responseType:'blob'})
}
export const exportYj03 = () => {
    return http.download('/api/export/yj03',undefined,{responseType:'blob'})
}
export const exportYj04 = () => {
    return http.download('/api/export/yj04',undefined,{responseType:'blob'})
}

